import React, { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';
import Notifications from '../../../services/notifications';
import SignatureContainer from '../../../commonComponents/SignatureContainer';
import OrderSummary from '../../shop/detail/components/OrderSummary';
import OrderProp from '../../shop/propTypes/orderProp';
import { useModal } from '../../../services/customHooks';
import SignatureModal from '../../../commonComponents/SignatureModal';
import ConfigsContext from '../../../contextProviders/ConfigsContext';
import CheckoutTerms from '../../shop/components/CheckoutTerms';
import { OPPORTUNITIES_STATUS } from '../components/helpers/opportunitiesListHelper';

const pendingStatus = [
  OPPORTUNITIES_STATUS.PENDING,
  OPPORTUNITIES_STATUS.QUALIFICATION,
  OPPORTUNITIES_STATUS.REFERENCES,
  OPPORTUNITIES_STATUS.LEADS,
  OPPORTUNITIES_STATUS.PROPOSAL,
];

function FooterSection(props) {
  const {
    t,
    opportunity,
    onAcceptOffer,
    onRejectOffer,
    isChecked,
    isLoading,
    onCheckboxChange,
  } = props;
  const { tenant } = useContext(ConfigsContext);
  const { signature } = opportunity;

  const [modal, showModal] = useModal({ show: false, data: null });

  const [initialSignature, setInitialSignature] = useState(signature || null);
  const signatureRef = useRef(null);
  const signatureModalRef = useRef(null);

  const { notes, status } = opportunity;
  const isStillPending = pendingStatus.includes(status);

  const handleAcceptOffer = () => {
    // Check if the signature is empty using the ref
    if (!signatureRef?.current || signatureRef.current.checkIfEmpty()) {
      Notifications.showNotificationError(
        t('error'),
        t('error.missing.signature'),
      );
      return;
    }
    onAcceptOffer(signatureRef.current.saveSignature());
  };

  const handleModal = signatureParam => {
    showModal({
      show: true,
      data: signatureParam,
    });
  };
  const handleModalClose = signatureParam => {
    setInitialSignature(signatureParam);
    showModal({
      show: false,
      data: null,
    });
  };

  const cxReject = cx(
    'btn',
    'btn-danger',
    'm-btn--pill',
    'reject-offer',
    { 'm-loader': isLoading.reject },
    { 'm-loader--right': isLoading.reject },
    { 'm-loader--light': isLoading.reject },
  );
  const cxApprove = cx(
    'btn',
    'btn-primary',
    'm-btn--pill',
    'accept-offer',
    { 'm-loader': isLoading.approve },
    { 'm-loader--right': isLoading.approve },
    { 'm-loader--light': isLoading.approve },
  );

  return (
    <>
      {modal?.show ? (
        <SignatureModal
          ref={signatureModalRef}
          initialSignature={modal.data}
          title={t('sign.document')}
          showClear={isStillPending}
          wrapperClass="signatureModalWrapper"
          onClose={handleModalClose}
          disabled={!isStillPending}
          showConfirm={isStillPending}
        />
      ) : null}
      <div className="m-portlet footer-section">
        <div className="notes-signature">
          {notes ? (
            <div className="notes-wrapper">
              <h5 className="header">{t('shop.cart.notes')}</h5>
              <p className="notes">{notes}</p>
            </div>
          ) : null}
          <SignatureContainer
            showClear={isStillPending}
            showExpand
            ref={signatureRef}
            onExpand={handleModal}
            initialSignature={initialSignature}
            disabled={!isStillPending}
          />
          {isStillPending ? (
            <CheckoutTerms
              onChange={onCheckboxChange}
              checked={isChecked}
              tenant={tenant}
            />
          ) : null}
        </div>
        <div className="footer-opportunity-detail">
          <h5 className="header">{t('shop.cart.estimation')}</h5>
          <OrderSummary
            order={opportunity}
            isOpportunity
            user={opportunity?.owner}
          />
          {isStillPending ? (
            <div className="offer-buttons">
              <button
                disabled={!isChecked || isLoading.approve || isLoading.reject}
                className={cxApprove}
                type="button"
                onClick={handleAcceptOffer}
              >
                {t('accept.offer')}
              </button>
              <button
                disabled={isLoading.approve || isLoading.reject}
                className={cxReject}
                type="button"
                onClick={onRejectOffer}
              >
                {t('reject.offer')}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

FooterSection.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
  onAcceptOffer: PropTypes.func.isRequired,
  onRejectOffer: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isLoading: PropTypes.shape({
    approve: PropTypes.bool,
    reject: PropTypes.bool,
  }).isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
};

export default translate(FooterSection);
